export enum TimeOfDayEnum {
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
  Night = 'night',
}

/**
 * @description Rules to determine the time of day across the codebase
 * Updating here will reflect uniformly across the site
 */
export const timeOfDayConfig = {
  [TimeOfDayEnum.Morning]: {
    start: 5,
    end: 12,
    emoji: '🌅',
  },
  [TimeOfDayEnum.Afternoon]: {
    start: 12,
    end: 17,
    emoji: '🌞',
  },
  [TimeOfDayEnum.Evening]: {
    start: 17,
    end: 21,
    emoji: '🌇',
  },
  [TimeOfDayEnum.Night]: {
    start: 21,
    end: 24,
    emoji: '🌙',
  },
};

export const PRE_DEFINED_TIME_KEYS = {
  today: 'Today',
  yesterday: 'Yesterday',
  previous7Days: 'Previous 7 Days',
  previous30Days: 'Previous 30 Days',
} as const;
